export const migrationRelayUrl =
  (window &&
    window.__RUNTIME_CONFIG__ &&
    window.__RUNTIME_CONFIG__.VITE_RELAY_URL) ||
  import.meta.env.VITE_RELAY_URL;

export const migrationApiUrl =
  (window &&
    window.__RUNTIME_CONFIG__ &&
    window.__RUNTIME_CONFIG__.VITE_API_URL) ||
  import.meta.env.VITE_API_URL;

export const argoBaseUri =
  (window &&
    window.__RUNTIME_CONFIG__ &&
    window.__RUNTIME_CONFIG__.VITE_ARGO_BASE_URL) ||
  import.meta.env.VITE_ARGO_BASE_URL;

export const admBaseUri =
  (window &&
    window.__RUNTIME_CONFIG__ &&
    window.__RUNTIME_CONFIG__.VITE_ADM_PREVIEW_BASE_DOMAIN) ||
  import.meta.env.VITE_ADM_PREVIEW_BASE_DOMAIN;

export const appName: string =
  (window &&
    window.__RUNTIME_CONFIG__ &&
    window.__RUNTIME_CONFIG__.VITE_APP_NAME) ||
  import.meta.env.VITE_APP_NAME ||
  "ADM Platform";
